import styled from "styled-components";
import React, { useEffect, useRef } from "react";

export const Embed = ({ html, meta }) => {
    const embedRef = useRef(null);
    useEffect(() => {
        if (embedRef.current != null) {
            // OMFG, this seems to be the "simplest" way to safely add scripts that are executed by the browser
            // without using jQuery ;)
            for (elt of embedRef.current.getElementsByTagName("script")) {
                const script = window.document.createElement("script");
                script.innerText = elt.innerText;
                for (attr of elt.attributes) {
                    script.setAttribute(attr.name, attr.value)
                }
                document.body.append(script)
            }
        }
    })
    if (meta.is_opaque_element) {
        return <EmbedElement>
            <EmbedOpaqueElement className="scp-embed-post-html-embed" ref={embedRef} dangerouslySetInnerHTML={{ __html: html }} ratio={meta.computed_ratio_pc} />
        </EmbedElement>
    } else {
        return <React.Fragment>
            <EmbedElement className="scp-embed-post-html-embed" ref={embedRef} dangerouslySetInnerHTML={{ __html: html }} />
        </React.Fragment>
    }
}

const EmbedElement = styled.div`
    width: 100%;
    overflow: hidden;
    text-align: center;
`;

const EmbedOpaqueElement = styled.div`
    position: relative;
    padding-bottom: ${props => props.ratio && props.ratio || "56.25%" /* 16:9 */};
    height: 0;
    object, embed, iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100% !important;
        height: 100%;
    }
`;